import { Timeline } from 'antd';
import styled from 'styled-components';

export const StyledTimeline = styled(Timeline)`
    .ant-timeline-item-head {
        border-color: var(--brand-6);
    }

    .ant-timeline-item-tail {
        border-color: var(--gray-4);
    }
`;
